import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import vid1 from "images/vid1.mp4";
import "../../main.css";
import logoImageSrc from "images/logo.png";
import serverIllustrationImageSrc from "images/server-illustration-2.svg";
import Header, {
  NavLink,
  NavLinks,
  PrimaryLink as PrimaryLinkBase,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from "../headers/light.js";

const StyledHeader = styled(Header)`
  ${tw`pt-8  w-full`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-white hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-blue-700`}
  }
`;

const PrimaryLink = tw(
  PrimaryLinkBase
)`shadow-raised lg:bg-blue-400 lg:hocus:bg-blue-500`;
const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 bg-center bg-cover h-screen min-h-144`}
  background-image: url("https://images.unsplash.com/photo-1536300007881-7e482242baa5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=80");
`;

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-black opacity-75`;

const HeroContainer = tw.div`z-20 relative px-6 sm:px-8 mx-auto h-full flex flex-col`;
const Content = tw.div`px-4 flex flex-1 flex-col justify-center items-center`;

const Heading = styled.h1`
  ${tw`text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-snug -mt-24 sm:mt-0 absolute`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const PrimaryAction = tw.button`rounded-full px-8 py-3 mt-10 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 bg-gray-100 font-bold shadow transition duration-300 bg-blue-500 text-gray-100 hocus:bg-blue-700 hocus:text-gray-200 focus:outline-none focus:shadow-outline`;

export default ({
  heading = "Toronto Web Developers",
  description = "Great Wave Digital specializes in creating custom built websites with modern and optimized designs. From website development, to SEO and marketing, our developers will esure you receive the best quality.",
  primaryButtonText = "Our Projects",
  primaryButtonUrl = "/components/innerPages/ProjectsPage",
  imageSrc = serverIllustrationImageSrc,
}) => {
  const logoLink = (
    <LogoLink href="/">
      <img src={logoImageSrc} alt="Logo" />
      Great Wave Digital
    </LogoLink>
  );
  const navLinks = [<NavLinks key={1}></NavLinks>];

  return (
    <section class="showcase">
      <video src={vid1} muted loop autoPlay></video>
      <div class="overlay"></div>
      {
        <div class="text">
          <h3>Toronto Sports</h3>
          <h3>And Entertainment News</h3>

          <p>
            Welcome to the Toronto Stats and Entertainment Hub. You can find
            everything Raptors, Maple Leafs, and Blue Jays!
          </p>
        </div>
      }
    </section>
  );
};
